import { all, select, call, put } from 'redux-saga/effects';
import { PapiRequestDaSharedGalleriesSearch } from '@wix/da-types-papi';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { request } from '@wix/da-shared-react/pkg/xhr';
import { getSearchQuery } from '../../selectors/gallectionSection';
import { getProfileOwner, getIsPagedMode } from '../../selectors/users';
import { GallectionSortOrder } from '../../../types/gallection';

function* fetchFromApi(params) {
  return yield call(request, {
    method: 'get',
    url: `/galleries/search`,
    params,
  });
}

export default function* fetchMoreDeviationSearchResults(action) {
  const { streamId } = action;

  const [
    offset,
    limit,
    searchQuery,
    profileOwner,
    sortOrder,
    isPaged,
  ] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(getSearchQuery),
    select(getProfileOwner),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'sortOrder')
    ),
    select(getIsPagedMode),
  ]);

  const queryParams: PapiRequestDaSharedGalleriesSearch = {
    userid: profileOwner.user.userId,
    order: sortOrder === GallectionSortOrder.NEWEST ? 'most-recent' : 'popular',
    q: searchQuery,
    init: isPaged || offset === 0,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response) {
    const { hasMore, nextOffset, estTotal, results: deviations } = response;
    const { result, entities } = normalize(deviations || [], [deviationSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        entities,
        total: estTotal,
      })
    );
  }

  // TODO error catching
}
